import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { AppConfigService } from '../services/base/app-config.service';
import { HttpClient } from '@angular/common/http';
import { ADMINAPIConstant } from '../constants/admin.constant';
import { NotificationService } from '../services/notification.service';
import { Location } from '@angular/common';

// Replace this with your actual user service
@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
    constructor(
        private router: Router, 
        private http: HttpClient, 
        private notificationService: NotificationService,
        private location: Location
    ) { }

    email!: string;
    apiBaseUrl = `${AppConfigService.settings.apiUrl}`;
    getCurrentFacilityId(): string {
        return localStorage.getItem('current_facility_id') || 'ES';
    }    getUserRole(): Observable<any> {
        this.email = sessionStorage.getItem('currentUser') || '';
        
        // Check if we have stored roles
        const storedRoles = sessionStorage.getItem('userRole');
        if (storedRoles) {
            try {
                const parsed = JSON.parse(storedRoles);
                
                if (Array.isArray(parsed)) {
                    const validRoles = parsed.filter(item => item !== null);
                    
                    if (validRoles.length > 0) {
                        return of(validRoles);
                    }
                    return this.fetchRolesFromServer();
                }
                
                if (parsed) {
                    return of(parsed);
                }
                
                return this.fetchRolesFromServer();
            } catch (error) {
                console.error('Error parsing user role:', error);
                return this.fetchRolesFromServer();
            }
        } else {
            return this.fetchRolesFromServer();
        }
    }
      private fetchRolesFromServer(): Observable<any> {
        return this.http.get(
            `${this.apiBaseUrl}Portal/RoleBasedMenu?facilityId=${this.getCurrentFacilityId()}`
        ).pipe(
            map((response: any) => {
                
                if (response && Array.isArray(response) && response.length > 0) {
                    const securityLevels = response
                        .filter((role: any) => role !== null && typeof role === 'object')
                        .map((role: any) => role.securityLevel)
                        .filter((level: any) => level !== undefined && level !== null);
                    
                    if (securityLevels.length > 0) {
                        sessionStorage.setItem('userRole', JSON.stringify(securityLevels));
                    }
                }
                
                return response;
            }),
            catchError(error => {
                console.error('Error fetching roles from server:', error);
                return of([]);
            })
        );
    }    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | boolean | UrlTree {
        // Store the current URL before checking permissions
        const currentUrl = this.router.url;
        const allowedRoles = route.data['roles'] as string[];
        const userRole = this.getUserRole();
        
        return userRole.pipe(
            map((roles: any) => {                
                if (Array.isArray(roles) && roles.length > 0 && typeof roles[0] === 'string') {
                    // Using already processed roles
                    if (!allowedRoles || allowedRoles.length === 0 || 
                        roles.some(role => allowedRoles.includes(role))) {
                        return true;
                    } else {
                        this.notificationService.showError('You do not have permission to access this page. Please contact your administrator.');
                        console.warn('User does not have required roles:', { required: allowedRoles, has: roles });
                        // Return current URL as UrlTree to prevent navigation
                        return this.router.parseUrl(currentUrl || '/');
                    }
                }
                
                if (!roles || !Array.isArray(roles)) {
                    console.warn('No valid roles found');
                    this.notificationService.showError('You do not have permission to access this page.');
                    // Return current URL as UrlTree to prevent navigation
                    return this.router.parseUrl(currentUrl || '/');
                }
                
                let securityLevels: string[] = [];
                
                // Try to extract security levels from the roles array
                if (roles.some(role => role !== null && typeof role === 'object')) {
                    securityLevels = roles
                        .filter((role: any) => role !== null && typeof role === 'object')
                        .map((role: any) => role.securityLevel)
                        .filter((level: any) => level !== undefined && level !== null);
                    
                    if (securityLevels.length > 0) {
                        sessionStorage.setItem('userRole', JSON.stringify(securityLevels));
                    }
                } else if (roles.some(role => role !== null)) {
                    securityLevels = roles.filter(role => role !== null);
                }
                  // Check if user has any of the allowed roles
                if (securityLevels.length > 0 && 
                    (!allowedRoles || allowedRoles.length === 0 || 
                     securityLevels.some(role => allowedRoles.includes(role)))) {
                    return true;
                }
                
                this.notificationService.showError('You do not have permission to access this page.');
                console.warn('User does not have required roles:', { required: allowedRoles, has: securityLevels });
                // Return current URL as UrlTree to prevent navigation
                return this.router.parseUrl(currentUrl || '/');
            }),            catchError((error) => {
                console.error('Error in role guard:', error);
                this.notificationService.showError('You do not have permission to access this page.');
                // Return current URL as UrlTree to prevent navigation
                return of(this.router.parseUrl(currentUrl || '/'));
            })
        );
    }
}